import { QueryClient } from "@tanstack/react-query";

import {
  CreateOrGetQuery,
  GetDaysByUserQuery,
  GetDaysByUserQueryVariables,
  useGetDaysByUserQuery
} from "./index.generated";

export const createOrGetDayOnCompleted = ({
  data,
  queryClient,
  variables
}: {
  data: CreateOrGetQuery;
  queryClient: QueryClient;
  variables: GetDaysByUserQueryVariables;
}) => {
  const daysData: GetDaysByUserQuery | null | undefined =
    queryClient.getQueryData(useGetDaysByUserQuery.getKey(variables));

  // console.log("daysData", daysData);

  let isDayInList = false;
  daysData?.days?.forEach((item) => {
    if (item?.date === data?.createOrGet?.data?.date) {
      isDayInList = true;
      return;
    }
  });

  // aggiorno la cache dei giorni se non è presente
  if (daysData && !isDayInList) {
    // console.log("adding new day");
    const prevDays = daysData?.days || [];

    const _data = {
      days: [...prevDays, data?.createOrGet?.data]
    };

    if (daysData) {
      queryClient.setQueryData(
        useGetDaysByUserQuery.getKey(variables),
        (_old: any) => _data
      );
    }
  }
};
